import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"color":"#499259"} }

import { i18n } from "@/i18n";
import { ProjectContainer } from "@/models/interfaces/project/project-models";
import { intlLocale } from "@/utils/format";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectFinanceSummary',
  props: {
    project: {},
    stacked: { type: Boolean, default: false }
  },
  setup(__props: any) {



const t = (key: string) => i18n.global.t(key);

// Формат чисел идентичен разделу финансов: по языку интерфейса, дробную часть до 4 знаков, нули не показываем
const money = (n: number | null | undefined) =>
	new Intl.NumberFormat(intlLocale(), {
		minimumFractionDigits: 0,
		maximumFractionDigits: 4,
	}).format(n || 0);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["finance-summary", { 'finance-summary--stacked': _ctx.stacked }])
  }, [
    _createElementVNode("span", null, [
      _createTextVNode(_toDisplayString(t('revenue_fact_plan')) + ": " + _toDisplayString(money(_ctx.project?.RevenueReal)), 1),
      _cache[0] || (_cache[0] = _createElementVNode("span", { style: {margin: '0 1px'} }, "/", -1)),
      _createTextVNode(_toDisplayString(money(_ctx.project?.RevenuePlanned)) + " (" + _toDisplayString(money(_ctx.project?.RevenuePercentage)) + "%) ", 1)
    ]),
    _createElementVNode("span", null, [
      _createTextVNode(_toDisplayString(t('balance_fact_plan')) + ": ", 1),
      _createElementVNode("span", _hoisted_1, _toDisplayString(money(_ctx.project?.BalanceReal)), 1),
      _cache[1] || (_cache[1] = _createElementVNode("span", { style: {margin: '0 1px'} }, "/", -1)),
      _createTextVNode(_toDisplayString(money(_ctx.project?.BalancePlanned)), 1)
    ])
  ], 2))
}
}

})